// @ts-nocheck

import React from 'react';

import useMergeProps from '../../hooks/useMergeProps';

import UserAccountGraphicsPreferences from './UserAccountGraphicsPreferences';

type UserAccountGraphicsPreferencesContainerProps = {
  className?: string;
};

const UserAccountGraphicsPreferencesContainer = (ownProps: UserAccountGraphicsPreferencesContainerProps) => {
  const enhancedProps = useMergeProps({ ownProps });

  return <UserAccountGraphicsPreferences {...enhancedProps} />;
};

export default UserAccountGraphicsPreferencesContainer;
